var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appdev-box"},[_c('div',{staticClass:"en-title"},[_vm._v(_vm._s("APP development".toUpperCase()))]),_c('div',{staticClass:"cn-title"},[_vm._v("APP开发")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.cleanHtmlText(_vm.data.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }